import type { IconDefinition as ReqularIconDefinition } from '@fortawesome/free-regular-svg-icons';
import type { IconDefinition as SolidIconDefinition } from '@fortawesome/pro-solid-svg-icons';
import type { IconDefinition as CoreIconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { ButtonProps } from 'react-bootstrap';

export interface ICustomButtonProps extends ButtonProps {
  'data-testid'?: string;
}

/**
 * Unified type for all FontAwesome packages, whose icons have an `iconName`
 * property that are only typed to the names included in their respective libraries.
 * TODO: Remove once all FontAwesome dependencies on same version
 */
export type IconDefinition = CoreIconDefinition | ReqularIconDefinition | SolidIconDefinition;

export interface PaginatedApiResponse<TResult> {
  count: number;
  next: string | null;
  previous: string | null;
  results: TResult[];
}

export const SORT_DIRECTIONS = {
  ascending: 'ascending',
  descending: 'descending',
} as const;

export type SortDirection = EnumObjectValues<typeof SORT_DIRECTIONS>;

export const QUERY_PARAM_KEYS = {
  page: 'page',
  pageSize: 'per_page',
  sortDirection: 'sort_order',
  sortField: 'sort_field',
} as const;
